document.querySelectorAll('.faq-section').forEach(section => {
    const entries = section.querySelectorAll('.faq-section-entry');

    entries.forEach(entry => {
        entry.addEventListener('click', e => {
            e.preventDefault();
            entries.forEach(entry => {
                entry.classList.remove('faq-section-active');
            });
            entry.classList.add('faq-section-active');
        });
    });

    const update = () => {
        entries.forEach(entry => {
            const answer = entry.querySelector('.faq-section-entry-answer');
            answer.style.height = answer.scrollHeight + 'px';
        });
    }

    update();
    window.addEventListener('resize', update);
    entries[0].classList.add('faq-section-active');
});